import {
  FAL_ASPECT_RATIO_LABELS,
  RESOLUTION_OPTION_LABELS,
} from '@/components/Nodes/ModelComponents/consts/model-image-size.const';

/**
 * Readable text for option values the generator's models store in lowercase. The canvas shows these values as
 * they are, so this map is only for the generator. Add a value here when a new model stores one that reads badly.
 */
const GENERATOR_OPTION_LABELS: Readonly<Record<string, string>> = {
  auto: 'Auto',
  '1k': '1K',
  '2k': '2K',
  '4k': '4K',
  low: 'Low',
  medium: 'Medium',
  high: 'High',
  standard: 'Standard',
  png: 'PNG',
  jpeg: 'JPEG',
  webp: 'WebP',
};

/** The text an option shows. Only the display changes: the run still sends `option`. */
export function optionLabel(key: string, option: string): string {
  return (
    GENERATOR_OPTION_LABELS[option] ??
    (key === 'resolution' ? RESOLUTION_OPTION_LABELS[option] : undefined) ??
    FAL_ASPECT_RATIO_LABELS[option] ??
    option
  );
}
